import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Restaurant, CustomerDeliveryAddress } from '@/models';

@Component({
  name: 'CmgRegionSwitchAlertModal',
})

export default class CmgRegionSwitchAlertModal extends Vue {
  get isPickup(): boolean {
    return this.$services.order.isPickingUp();
  }

  get selectedRestaurant(): Restaurant | null {
    return this.$appStore.state.restaurant.selectedRestaurant;
  }

  get selectedDeliveryAddress(): CustomerDeliveryAddress | null {
    return this.$appStore.state.order.selectedDeliveryAddress;
  }

  get countryCode(): string | undefined | null {
    return this.isPickup
      ? this.selectedRestaurant && this.selectedRestaurant!.address.countryCode
      : this.selectedDeliveryAddress && this.selectedDeliveryAddress!.countryCode;
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.regionSwitchAlertModal.visible;
  }
  
  onClickNewSearch(): void {
    this.$services.ui.setModalVisibility('regionSwitchAlertModal', false);
  }
}